import Collections from './Collections'
import Maps from './Maps'
import Members from './Members'
import Settings from './Settings'

import { useCurrentTab } from '~workspace/states/ui'

const TAB = {
  MAPS: 'Maps',
  COLLECTIONS: 'Collections',
  MEMBERS: 'Members',
  SETTINGS: 'Settings'
}

const Tab = () => {
  const currentTab = useCurrentTab()

  switch (currentTab) {
    case TAB.MAPS:
      return <Maps />
    case TAB.COLLECTIONS:
      return <Collections />
    case TAB.MEMBERS:
      return <Members />
    case TAB.SETTINGS:
      return <Settings />
    default:
      return null
  }
}

export { Tab }
export default Tab
